import './cardSelectorView.scss';
import React, { useEffect, useState } from 'react';
import { FormattedText, i18n } from 'core/i18n';
import PropTypes from 'prop-types';
import { RoadmapNavigation } from 'components/steps/roadmapNavigation';
import { Header } from 'components/header/header';
import Headline from 'components/headline';
import { OKCardSelector } from 'commonsComponents/OKCardSelector';
import { PAGE_PRODUCT, recordEvent, recordEventCustomOnly } from 'utilities/uTagging';
import { PATH_SELECT_CARD } from 'constants/uTagConstants/paths';
import { isPinNotRequired } from 'utilities/debitCard';
import cryptoJS from 'crypto-js';
import { MIN_CARDS_TO_SELECT } from './constants';

const getListByKeys = keysArray => {
    const { formatText } = i18n;
    const arrLength = keysArray.length;
    let listString = '';
    if (arrLength > 0) {
        listString = `${formatText(keysArray[arrLength - 1])}.`;
    }
    if (arrLength > 1) {
        listString = `${formatText(keysArray[arrLength - 2])} ${formatText('initialCardSelector-or')} ${listString}`;
    }

    if (arrLength > 2) {
        for (let index = arrLength - 3; index >= 0; index--) {
            listString = `${formatText(keysArray[index])}, ${listString}`;
        }
    }

    return listString;
};

const CardSelectorView = ({ userProfile, cardImages, debitCardActions, modalCancelActions }) => {
    const cardImagesLocal = cardImages.toJS().cardImagesArray;
    const [imageCard, setImageCard] = useState();

    useEffect(() => {
        if (!imageCard && cardImagesLocal && cardImagesLocal[0]) {
            setImageCard(cardImagesLocal[0]);
        }
    }, [cardImagesLocal, imageCard]);

    const recordEventByAction = (action, cardSelected) => {
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        recordEvent(
            PATH_SELECT_CARD,
            PAGE_PRODUCT,
            action,
            cardSelected.poeditorKey,
            userProfile.recordId,
            '',
            '',
            userProfile.investmentType,
            docNumberEncrypted
        );
    };

    const onHandleImageCard = imageCardId => {
        const cardSelectedInfo = cardImagesLocal.filter(card => card.id === imageCardId)[0];
        recordEventByAction('modelo de tarjeta', cardSelectedInfo);
        setImageCard(cardSelectedInfo);
    };

    const onHandleCancelButton = () => {
        recordEventCustomOnly({
            categoriaEvento: 'eventos onboarding',
            accionEvento: 'clic',
            etiquetaEvento: 'salir',
        });

        modalCancelActions.showModalCancel();
    };
    const onHandleContinueButton = () => {
        recordEventCustomOnly({
            categoriaEvento: 'eventos onboarding',
            accionEvento: 'clic',
            etiquetaEvento: 'continuar',
            event_name: 'button_click',
            action: 'click',
            format: 'button',
            component: 'form',
            element: 'continue',
        });

        if (isPinNotRequired()) {
            debitCardActions.selectPinDebitCard(imageCard);
        } else {
            debitCardActions.selectDebitCard(imageCard);
        }
        recordEventByAction('siguiente', imageCard);
    };

    const getTitleList = () => {
        const keys = cardImagesLocal.map(e => e.poeditorKey);

        return getListByKeys(keys);
    };

    const notShowCardSelection = () => cardImagesLocal.length < MIN_CARDS_TO_SELECT && isPinNotRequired();

    return notShowCardSelection() ? null : (
        <div className="card-selector-view">
            <Header steps={false} />
            <div className="card-selector-view__content">
                <Headline icon="tarjeta" className="prospects-gutter card-selector-view__content__headline">
                    <h2>
                        <FormattedText value="initialCardSelector-headerTitle" />
                    </h2>
                    <p>
                        <FormattedText value="initialCardSelector-headerDescription" />
                    </p>
                </Headline>
                <div className="card-selector-view__content__cards">
                    <h4>
                        <FormattedText value="initialCardSelector-selectorTitle" />
                    </h4>
                    {cardImagesLocal.length > 0 && (
                        <div className="card-selector-view__content__cards__container">
                            <p className="card-selector-view__content__cards__description">{getTitleList()}</p>
                            <OKCardSelector
                                cards={cardImagesLocal}
                                selected={imageCard ? imageCard.id : 0}
                                callBack={onHandleImageCard}
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className="form__footer">
                <RoadmapNavigation
                    buttonContinueType="submit"
                    buttonPrevHidden
                    buttonCancelAction={onHandleCancelButton}
                    buttonContinueClass="form__button form__button-secondary"
                    buttonContinueDisabled={!imageCard}
                    buttonContinueAction={onHandleContinueButton}
                />
            </div>
        </div>
    );
};

CardSelectorView.propTypes = {
    userProfile: PropTypes.object.isRequired,
    cardImages: PropTypes.object.isRequired,
    debitCardActions: PropTypes.object.isRequired,
    modalCancelActions: PropTypes.object.isRequired,
};
export { CardSelectorView };
